import React from 'react';
import { FormOutlined, SendOutlined, } from '@ant-design/icons';
import {
    Form,
    Button,
    Space,
    List,
    message,
    Typography, 
    Input,
    Modal,
    Image,
} from 'antd';
import './LZHXOrderForm.css';
import axios from 'axios';
import qs from 'qs';

const { Paragraph, Text } = Typography;
// const baseUrl = "https://47.100.83.180/laizeAdmin";
// const baseUrl = "http://localhost:8080/laizeAdmin";
const baseUrl = "https://www.laizekeji.cn/laizeAdmin";
const placeholderImage = "http://47.92.85.113/laizehomeImg/placeholder.png";

const orderInfoKeys = [
    "goodsInfo",
    "orderInfo",
    "completeAddressInfo",
    "remark",
    "action",
];

class HXOrderForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalVisible : false,
            originalContent : "",
            orderInfoList: {},
        }
        this.fetchListItemForKey = this.fetchListItemForKey.bind(this);
    }

    componentDidMount() {
        
    }

    sendOrderInfoToUser() {
        let order = this.props.orderDetail.order || {};
        let address = this.props.orderDetail.address || {};
        let goodsInfo = this.props.orderDetail.goodsDTOList || [];
        let firstGoods = goodsInfo[0] || {};

        var standardData = {
            easemob: {
                kefu: {
                    articles: [{
                        lztype:"order",
                        title: "订单完整信息",
                        url: "https://www.laizekeji.cn/hxcomponent/index.html?to=orderDetail&orderId="+(order.id ||""),
                        picurl: firstGoods.specificationImage.replace("http://47.92.85.113", "https://www.laizekeji.cn")||placeholderImage,
                        thumbUrl: "https://www.laizekeji.cn/laizehomeImg/placeholder.png",
                        jump: {
                            des: "order",
                            params: {
                                id: order.id || "",
                                url: "https://www.laizekeji.cn/hxcomponent/index.html?to=orderDetail&orderId="+(order.id ||""),
                            },
                        },
                        orderId: order.id || null,
                        productImage: firstGoods.specificationImage.replace("http://47.92.85.113", "https://www.laizekeji.cn")||placeholderImage,
                        productTitle: firstGoods.specificationName||"无",
                        productNum: goodsInfo.length || 0,
                        finalPrice: order.finalPrice || "0",
                        addrName: address.name || "无",
                        addrPhone: address.phone || "无",
                        addressInfo: (address.area || "无") + (address.address  || "无")
                    }],
                }
            }
        };
        
        window.parent.postMessage(standardData, '*');
    }

    modifyAddressInfo() {
        this.setState({
            isModalVisible: true,
            originalContent : this.props.orderDetail.order.remark || "无",
        });
    }

    changeContent(e) {
        console.log(e.target.value);
        this.currentContent = e.target.value;
    }

    cancelModal() {
        this.setState({
            isModalVisible: false,
            originalContent : "",
        });
    }

    confirmModal() {
        let order = this.props.orderDetail.order || {};
        
        axios.post(baseUrl + '/hxcomponent/modifyOrderRemarkById', qs.stringify({
            id: order.id || "",
            remark: this.currentContent || "",
        }))
            .then(function (res) {
                message.info(res.data.message);
            })
            .catch(function (error){
                console.log(error);
                message.info(error.data.message);
            });

        this.setState({
            isModalVisible: false,
            originalContent : "",
        });
    }

    fetchListItemForKey(item) {
        console.log(item.item);

        let key = item.item || "";

        let order = this.props.orderDetail.order || {};
        let address = this.props.orderDetail.address || {};
        let goodsInfo = this.props.orderDetail.goodsDTOList || [];
        goodsInfo = goodsInfo.map(function (item) {
            let price = order.priceIncludeTax === "订单含税" ? item.priceWithTax : item.price;
            item.curPrice = price;
            return item;
        });
        
        if (key == "goodsInfo") {
            return (
                <>
                    <List
                        itemLayout={"vertical"}
                        dataSource={goodsInfo}
                        renderItem={item => (
                            <List.Item>
                                <Space>
                                    <Image width={60} height={60} src={encodeURI(item.specificationImage.replace("http://47.92.85.113", "https://www.laizekeji.cn")||placeholderImage)} />
                                    <div>
                                        <div style={{textAlign:'left'}}> {item.goodsName||"无"} </div>
                                        <div style={{textAlign:'left', color:'#A9A9A9'}}> {item.specificationName||"无"} </div>
                                        <div style={{textAlign:'left'}}> ¥{item.curPrice||"0"} x{item.num||"无"} </div>
                                    </div>
                                </Space>
                            </List.Item>
                        )}
                    />
                    <div className="lineView"/>
                </>
            );
        } else if (key == "orderInfo") {
            return (
                <>
                    <div className="orderInfo">
                        <div> 
                            <span className="orderListTitle">总金额:</span> {"¥" + (order.finalPrice || "0")}  
                            <span style={{color:"#999999"}}> (含运费:{"¥" + (order.expressFee || "0")})</span> 
                        </div>
                        <div> <span className="orderListTitle">订单号:</span> <Text copyable>{order.orderNum}</Text> </div>
                        <div> <span className="orderListTitle">订单状态:</span> {order.status} </div>
                        <div> <span className="orderListTitle">配送方式:</span> {order.deliverWay || "无"} </div>
                        <div> <span className="orderListTitle">快递单号:</span> {order.delayNum || "无"} </div>
                        <div> <span className="orderListTitle">是否含税:</span> {order.priceIncludeTax || "无"} </div>
                    </div>
                    <div className="lineView"/>
                </>
            );
        } else if (key == "completeAddressInfo") {
            return (
                <>
                    <div className="addressInfo">
                        <span className="orderListTitle">详细地址:</span>
                        {address.name || "无"}{"   "}
                        {address.phone || "无"}{"   "}
                        {(address.area || "无") + (address.address  || "无")}
                    </div>
                    <div className="lineView"/>
                </>
            );
        } else if (key == "remark") {
            return (
                <>
                    <div className="addressInfo">
                        <span className="orderListTitle">留言信息:</span>
                        {order.remark || "无"}
                    </div>
                    <div className="lineView"/>
                </>
            );
        } else if (key == "action") {
            return (
                <Space wrap>
                    <Button className="operatorBtn" type="primary" size="small" shape="round" onClick={this.sendOrderInfoToUser.bind(this)}>发订单</Button>
                    <Button className="operatorBtn" type="primary" size="small" shape="round" onClick={this.modifyAddressInfo.bind(this)}>改备注</Button>
                </Space>
            );
        } else {
            return <div/>;
        }
    }

    render() {
        let order = this.props.orderDetail.order || {};
        let address = this.props.orderDetail.address || {};
        let goodsInfo = this.props.orderDetail.goodsDTOList || [];
        goodsInfo = goodsInfo.map(function (item) {
            let price = order.priceIncludeTax === "订单含税" ? item.priceWithTax : item.price;
            item.curPrice = price;
            return item;
        });

        return (
            <>
                <div className="orderContainer">
                    {orderInfoKeys.map(item => {
                        return this.fetchListItemForKey({item})
                    })}
                </div>
                <Modal title="修改留言" visible={this.state.isModalVisible} onOk={this.confirmModal.bind(this)} onCancel={this.cancelModal.bind(this)} destroyOnClose={true}>
                    <p>{this.state.originalContent}</p>
                    <Input onChange={this.changeContent.bind(this)}/>
                </Modal>
            </>
        );
    }
};

export default HXOrderForm;